export function injectStrict<T>(key: InjectionKey<T>, fallback?: T): T {
  const resolved = inject(key, fallback)
  if (!resolved) {
    throw new Error(`Could not resolve ${key.description}`)
  }
  return resolved
}

let versionCache: null | string = null
export async function getAppVersion(): Promise<string> {
  if (import.meta.server) {
    const config = useRuntimeConfig()
    return config.public.appVersion
  }
  try {
    if (!isEmpty(versionCache)) {
      return versionCache
    }
    const res = await fetch('/version.json', {
      cache: 'no-store',
    })

    const json = await res.json()

    if (json?.version) {
      versionCache = json.version
      return json.version
    }

    throw new Error('version missing')
  } catch (e) {
    console.warn('[App] Failed to load version.json', e)

    // ⛑ fallback ТОЛЬКО если сеть реально умерла
    const config = useRuntimeConfig()
    return config.public.appVersion
  }
}
